export default __webpack_public_path__ + "static/media/profile.f8e8de92.svg";